// src/utils/decimalUtils.js
import Decimal from 'decimal.js';

Decimal.set({
  precision: 40,
  rounding: Decimal.ROUND_HALF_UP
});

/**
 * Core wrapper
 * - Never returns NaN
 * - Never throws on null/undefined/""
 */
function toDec(value) {
  // console.log(value);
  if (value === null || value === undefined || value === '') {
    return new Decimal(0);
  }

  return Decimal.isDecimal(value)
    ? value
    : new Decimal(value);
}

/**
 * Formatting (UI / SQL ONLY)
 */
function format(val, decimals = 2) {
  return toDec(val).toFixed(decimals);
}

/**
 * Currency conversion
 * - NO formatting
 * - Always returns Decimal
 */
function toUSD(amount, currency, exchangeRate) {
  const a = toDec(amount);

  if (currency === '$') return a;

  return a.div(toDec(exchangeRate));
}

function toPEN(amount, currency, exchangeRate) {
  const a = toDec(amount);

  if (currency === 'S/.') return a;

  return a.times(toDec(exchangeRate));
}

/**
 * Comparisons (safe & explicit)
 */
function equals(a, b, tolerance = '0.01') {
  return toDec(a).minus(toDec(b)).abs().lte(toDec(tolerance));
}

export default {
  Decimal,
  toDec,

  // formatting
  format,

  // conversion
  toUSD,
  toPEN,

  // comparison
  equals
};